module.exports = __webpack_public_path__ + "img/周口市-c.b2419e3b.png";